<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <CompanyBreadcrumb :aria-label="isEditMode ? $t('survey.edit') : $t('survey.add')"
                           :home-aria-label="$t('general.home')"
                           :items="breadcrumbItems"
                           class="mb-md-3"
        />
      </div>

      <template v-for="(error, index) in errorMessages">
        <div v-if="error != null" :key="'error-' + index" class="uk-alert uk-alert-danger" style="position: relative;">
          <button
              class="uk-alert-close"
              style="cursor: pointer; border: none; background: transparent; opacity: 0.4;"
              type="button"
              @click.stop.prevent="removeError(index)">
            ×
          </button>
          <p style="color: red; margin: 0; padding-right: 30px;">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>

      <div class="card position-relative p-0">
        <div class="card-body">

          <!-- Edit modunda tek sekme kaliyor; nav CSS ile gizleniyor
               (formu ikinci kez yazmamak icin) -->
          <CompanyTabs :class="{ 'survey-tabs--single': isEditMode }"
                       :tabs="surveyTabs"
                       class="survey-tabs"
                       content-id="survey_add_switcher_list"
                       nav-id="survey_add_switcher_tab"
          >
            <li>

              <div class="mt-4 position-relative">

                <div v-if="loading"
                     style="position: absolute; height: 100%; width: 100%; z-index: 999; background: rgba(238, 238, 238, 0.5); display: flex; justify-content: center; align-items: center">
                  <div class="text-info" uk-spinner="ratio: 4"></div>
                </div>

                <div class="card-body-survey">
                  <h4>
                    <i class="uil-question-circle"></i>
                    {{ isEditMode ? $t("survey.edit") : $t("survey.add") }}
                  </h4>
                  <hr/>
                  <div class="row">
                    <div class="col-xl-9 m-auto">
                      <form action="" novalidate="novalidate">
                        <div class="form-group row mb-3 align-items-center">
                          <label class="col-md-3 col-form-label" for="course_title">
                            {{ $t("survey.name") }} <span class="required">*</span>
                          </label>
                          <div class="col-md-9">
                            <input id="course_title" v-model="name" class="form-control mb-0" name="title"
                                   required="" type="text"/>
                          </div>
                        </div>

                        <div v-if="!isEditMode" class="form-group row mb-3">
                          <label class="col-md-3 col-form-label" for="passmark">
                            {{ $t("survey.point") }} (0-100)<span class="required">*</span>
                          </label>
                          <div class="col-md-9">
                            <input id="passmark" v-model="point" :placeholder="$t('survey.enter_point')"
                                   class="form-control" required="" type="text"/>
                          </div>
                        </div>

                        <div v-if="!isEditMode" class="d-flex justify-content-end align-items-center">
                          <toggle-button v-model="is_compulsory"
                                         :labels="{ checked: $t('survey.compulsory'), unchecked: $t('survey.not_compulsory') }"
                                         :sync="true" :width="140" color="#ae71ff"/>
                        </div>

                        <div v-if="isEditMode" class="d-flex justify-content-end align-items-center">
                          <toggle-button v-model="is_default" :labels="{ checked: $t('survey.default'), unchecked: $t('survey.not_default') }" :sync="true" :width="140"
                                         color="#ae71ff"/>
                        </div>

                        <div
                            class="d-flex align-content-center justify-content-end table-vertical-center align-items-center">
                          <toggle-button v-model="status_id"
                                         :labels="{ checked: $t('survey.active'), unchecked: $t('survey.inactive') }"
                                         :sync="true"
                                         :width="140" color="#ae71ff"/>
                        </div>

                        <div
                            class="d-flex align-content-center justify-content-end table-vertical-center align-items-center mt-2">
                          <span class="mr-2">
                            {{ $t('general.mail_notification') }}
                            <i class="uil-info-circle"
                               style="margin-left: 6px; cursor: pointer;"
                               :uk-tooltip="'title: ' + $t('general.survey_completion_manager_email_info')"></i>
                          </span>
                          <toggle-button v-model="send_completion_email"
                              :labels="{ checked: $t('general.yes'), unchecked: $t('general.no') }"
                              :sync="true"
                              :width="140"
                              color="#ae71ff"/>
                        </div>

                        <hr/>

                        <div class="questions-area">
                          <div v-for="(question, index) in questions" :key="'question_' + index" class="question-item">
                            <div class="d-flex justify-content-between survey-question-head">
                              <h4>{{ $t('survey.question') }} #{{ index + 1 }}</h4>
                              <button class="btn btn-outline-danger btn-sm" type="button"
                                      @click="deleteQuestion(index, question.id)">
                                <i class="uil-trash"></i> {{ $t("survey.delete_question") }}
                              </button>
                            </div>
                            <hr>
                            <div class="form-group row mb-3 align-items-center">
                              <label :for="'question_name_' + index" class="col-md-3 col-form-label">
                                {{ $t('survey.question_name') }} <span class="required">*</span>
                              </label>
                              <div class="col-md-9">
                                <input :id="'question_name_' + index" v-model="question.name"
                                       class="mb-0 form-control" type="text">
                              </div>
                            </div>
                            <div class="form-group row mb-3 align-items-center">
                              <label class="col-md-3 col-form-label">{{ $t('survey.question_type') }}</label>
                              <div class="col-md-9">
                                <span v-if="question.type === 1">{{ $t('general.multiple_choice') }}</span>
                                <span v-if="question.type === 2">{{ $t('survey.type_textarea') }}</span>
                              </div>
                            </div>

                            <div v-if="question.type === 1">
                              <hr>
                              <h5>{{ $t('survey.options') }}</h5>
                              <hr>
                              <div v-for="(option, optionIndex) in question.options" :key="'opt_' + optionIndex">
                                <div class="survey-option-row">
                                  <div class="p-2 survey-option-field survey-option-field--label">
                                    <label class="survey-option-label">{{ $t('survey.option_label') }} #{{
                                        optionIndex + 1
                                      }}</label>
                                    <input v-model="option.label" class="form-control mb-0" type="text">
                                  </div>
                                  <div class="p-2 survey-option-field survey-option-field--point">
                                    <!-- Kisa etiket: kolonun genisligini etiket metni
                                         belirliyor, "Secenek Puani #1" kolonu ~140px'e
                                         sisiriyordu. Tek haneli puan icin gereksiz. -->
                                    <label class="survey-option-label">
                                      {{ $t('general.point') }} #{{ optionIndex + 1 }}
                                    </label>
                                    <multiple-select-input :allow-empty="false"
                                                          :searchable="false"
                                                          :show-labels="false"
                                                          :value="pointOption(option, question)"
                                                          :values="pointOptions(question)"
                                                          class="mb-0 survey-point-select"
                                                          @input="option.point = $event ? $event.id : null"
                                    />
                                  </div>
                                  <!-- align-items: flex-end ile hizalaniyor; eskiden
                                       `margin-top: 1.8rem` sihirli offseti vardi ve
                                       etiket satir kirdiginda kayiyordu. -->
                                  <div v-if="optionIndex > 1" class="p-2 survey-option-remove">
                                    <button class="uk-button uk-text-warning"
                                            type="button" @click="deleteOption(optionIndex, index)">
                                      <i class="uil-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="p-2">
                                <button v-if="question.options.length < 5" class="uk-button uk-button-primary small"
                                        type="button" @click="addOption(index)">
                                  <i class="uil-plus m-0"></i>{{ $t('general.add_option') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex justify-content-between survey-add-question">
                          <multiple-select-input v-model="selectedQuestionTypeOption"
                                                 :allow-empty="false"
                                                 :searchable="false"
                                                 :show-labels="false"
                                                 :values="questionTypeOptions"
                                                 class="mx-1 survey-question-type-select"
                          />
                          <input :value="$t('survey.add_question')" class="btn btn-lg btn-outline-primary" type="button"
                                 @click="addQuestion"/>
                        </div>

                        <hr>

                        <div class="uk-card-footer d-flex justify-content-end pb-0 pr-0 align-items-center survey-form-footer">
                          <button class="uk-button uk-button-primary small" type="button" @click="saveForm">
                            <i class="icon-feather-arrow-right"></i> {{ isEditMode ? $t('general.update') : $t("general.save") }}
                          </button>
                          <button v-if="!isEditMode" :disabled="!$hasPermission('create_assignment')" :style="{ cursor: !$hasPermission('create_assignment') ? 'not-allowed' : 'pointer' }"
                                  class="uk-button uk-button-primary small"
                                  type="button"
                                  @click="saveForm('assign_page')">
                            <i class="uil-location-arrow"></i>
                            {{ $t("general.save_and_assign") }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <!-- Excel ile ekleme - Sadece Add modunda -->
            <li v-if="!isEditMode">
              <survey-from-excel-uploader :sample-excel-endpoint="'/api/survey/sample-excel'"
                                          @imported="handleImportedExcelData"/>
            </li>
          </CompanyTabs>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import store from "@/core/services";
import module, {
  BASE_URL,
  MODULE_NAME,
  CREATE_ITEM,
  UPDATE_ITEM,
  GET_ITEM,
  DELETE_QUESTION,
  RESET_VALUES,
  ITEM,
  LOADING,
  ERROR,
  SUCCESS
} from "@/core/services/store/survey.module";
import SurveyFromExcelUploader from "@/view/components/uploader/SurveyFromExcelUploader.vue";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import CompanyTabs from "@/view/company/components/tabs/CompanyTabs.vue";
import { showError, showSuccess } from "@/utils/alertUtils";

export default {
  name: "SurveyAddEdit",
  components: { SurveyFromExcelUploader, CompanyBreadcrumb, MultipleSelectInput, CompanyTabs },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(MODULE_NAME, module)
  },
  data() {
    return {
      errorMessages: [],
      selected_question_type: 1, // 1: dropdown, 2: textarea
      questions: [],
      name: null,
      status_id: true,
      is_compulsory: false,
      is_default: false,
      send_completion_email: false,
      point: 0,
    }
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    surveyTabs() {
      const tabs = [
        { key: "manual", icon: "uil-user-plus", label: this.$t("general.add_survey_question") },
      ];
      if (!this.isEditMode) {
        tabs.push({ key: "excel", icon: "uil-table", label: this.$t("users.add_to_excel") });
      }
      return tabs;
    },
    breadcrumbItems() {
      return [
        { name: this.$t("survey.surveys") },
        { name: this.isEditMode ? this.$t("survey.edit") : this.$t("survey.add") },
      ];
    },
    questionTypeOptions() {
      return [
        { id: 1, name: this.$t("general.multiple_choice") },
        { id: 2, name: this.$t("survey.type_textarea") },
      ];
    },
    // MultipleSelectInput nesne bekliyor, selected_question_type ise sayi
    selectedQuestionTypeOption: {
      get() {
        return this.questionTypeOptions.find((o) => o.id === this.selected_question_type)
            || this.questionTypeOptions[0];
      },
      set(value) {
        this.selected_question_type = value && value.id ? value.id : 1;
      },
    },
    loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    surveyItem: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    success: {
      get() {
        return store.getters[MODULE_NAME + "/" + SUCCESS];
      },
      set(value) {
      },
    },
  },
  methods: {
    removeError(index) {
      this.errorMessages.splice(index, 1);
    },
    // MultipleSelectInput nesne bekliyor; option.point ise sayi tutuyor
    pointOptions(question) {
      return question.options.map((_, i) => ({ id: i + 1, name: String(i + 1) }));
    },
    pointOption(option, question) {
      return this.pointOptions(question).find((o) => o.id === Number(option.point)) || null;
    },
    loadSurveyData() {
      if (this.isEditMode && this.surveyItem && this.surveyItem.id) {
        this.name = this.surveyItem.name;
        this.status_id = parseInt(this.surveyItem.status_id) === 1;
        this.is_default = parseInt(this.surveyItem.is_default) === 1;
        this.send_completion_email = this.surveyItem.send_completion_email === true
            || parseInt(this.surveyItem.send_completion_email) === 1;

        this.questions = [];
        if (this.surveyItem.questions && this.surveyItem.questions.length > 0) {
          this.surveyItem.questions.forEach(question => {
            this.questions.push({
              id: question.id,
              name: question.name,
              type: question.type,
              options: question.options && Array.isArray(question.options)
                  ? question.options
                  : JSON.parse(question.options)
            });
          });
        }
      }
    },
    handleImportedExcelData(datax) {
      this.questions = [];

      const importedQuestions = datax
          .filter(data => data)
          .map((data) => {
            const questionText = data[0];
            const questionTypeText = data[1];

            let questionType;
            if (questionTypeText === this.$t('general.multiple_choice')) {
              questionType = 1;
            } else if (questionTypeText === this.$t('evaluation_survey.type_textarea')) {
              questionType = 2;
            } else {
              console.warn("Unrecognized question type:", questionTypeText);
              return null;
            }

            if (questionType === 1) {
              const options = data.slice(2)
                  .filter(option => option !== null && option !== '')
                  .map((option, index) => ({
                    label: option.toString(),
                    point: index + 1
                  }));

              return options.length > 0 ? {
                name: questionText,
                type: questionType,
                options: options
              } : null;
            } else if (questionType === 2) {
              return {
                name: questionText,
                type: questionType,
                options: []
              };
            }

            return null;
          })
          .filter(question => question !== null);

      this.questions = [...this.questions, ...importedQuestions];

      if (this.questions.length === 0) {
        showError(this.$t('general.empty_or_incorrect_language_excel'))
        return
      }

      this.switchToFirstTab()
    },
    switchToFirstTab() {
      // id, CompanyTabs'a nav-id olarak veriliyor
      const element = document.getElementById('survey_add_switcher_tab');
      if (element) {
        UIkit.switcher(element).show(0);
      }
    },
    deleteOption(optionIndex, questionIndex) {
      this.questions[questionIndex]['options'].splice(optionIndex, 1);
      // Puanları yeniden sırala (1'den başlayarak)
      this.questions[questionIndex]['options'].forEach((option, index) => {
        option.point = index + 1;
      });
    },
    addOption(questionIndex) {
      this.questions[questionIndex]['options'].push({
        label: null,
        point: this.questions[questionIndex]['options'].length + 1,
      })
    },
    validateForm() {
      this.resetMessages();
      let isValid = true;

      // Anket adı kontrolü
      if (this.name == null || this.name.length < 3) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.name"))
        );
        isValid = false;
      }

      // Puan kontrolü (sadece add modunda)
      if (!this.isEditMode && (this.point == null || +this.point == 0 || +this.point > 100)) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.point"))
        );
        isValid = false;
      }

      // En az bir soru olmalı
      if (this.questions.length === 0) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", this.$t("survey.questions"))
        );
        isValid = false;
      }

      // Soru ve seçenek kontrolü
      this.questions.forEach(question => {
        if (question.name == null || question.name.trim() === '') {
          this.errorMessages.push(
              this.$t("validation.required_field").replace(":NAME", this.$t("survey.question_name"))
          );
          isValid = false;
        }
        
        // Çoktan seçmeli sorularda seçenek kontrolü
        if (question.type === 1) {
          question.options.forEach(option => {
            if (option.label == null || option.label.trim() === '') {
              this.errorMessages.push(
                  this.$t("validation.required_field").replace(":NAME", this.$t("survey.option_label"))
              );
              isValid = false;
            }
          });
        }
      });

      if (!isValid) {
        this.scrollToTop();
      }

      return isValid;
    },
    prepareQuestionsData() {
      let questions = [];
      this.questions.forEach(question => {
        let preparedQuestion = Object.assign({}, question);
        preparedQuestion.options = JSON.stringify(question.options);
        questions.push(preparedQuestion);
      });
      return questions;
    },
    saveForm(process_type) {
      let self = this;

      if (!this.validateForm()) {
        return;
      }

      let questions = this.prepareQuestionsData();

      if (self.isEditMode) {
        // Update existing survey
        store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + self.$route.params.id,
          contents: {
            name: self.name,
            status_id: self.status_id,
            is_default: self.is_default,
            send_completion_email: self.send_completion_email,
            questions: questions
          }
        }).then(() => {
          showSuccess(self.$t("general.successfully_updated"))
          this.$router.push({ name: "company.surveys.list" });
        });
      } else {
        // Create new survey
        store.dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
          url: BASE_URL,
          contents: {
            name: self.name,
            status_id: self.status_id,
            is_compulsory: self.is_compulsory,
            send_completion_email: self.send_completion_email,
            point: self.point,
            questions: questions
          }
        }).then((response) => {
          showSuccess(self.$t("general.successfully_created"))

          if (process_type === 'assign_page') {
            this.$router.push({
              name: "company.assignments.add",
              params: { id: response.content_id, title: response.name, name: this.$t('general.survey') }
            });
          } else {
            this.$router.push({ name: "company.surveys.list" });
          }
        })
      }
    },
    addDropdownQuestion() {
      let question = {
        id: this.isEditMode ? 0 : undefined,
        name: null,
        type: 1,
        options: [
          {
            label: null,
            point: 1,
          },
          {
            label: null,
            point: 2,
          }
        ]
      };
      this.questions.push(question);
    },
    addTextareaQuestion() {
      let question = {
        id: this.isEditMode ? 0 : undefined,
        name: null,
        type: 2,
        options: []
      };

      this.questions.push(question);
    },
    addQuestion() {
      switch (this.selected_question_type) {
        case 1:
          this.addDropdownQuestion();
          break;
        case 2:
          this.addTextareaQuestion();
          break;
      }
    },
    deleteQuestion(index, id) {
      if (this.isEditMode && id > 0) {
        store.dispatch(MODULE_NAME + '/' + DELETE_QUESTION, {
          url: BASE_URL + '/delete-question/' + id
        });
      }
      this.questions.splice(index, 1);
    },
    getItem() {
      if (this.isEditMode) {
        store.dispatch(MODULE_NAME + '/' + GET_ITEM, {
          url: BASE_URL + '/' + this.$route.params.id,
        });
      }
    },
    // Add ve edit ayni component; route degisiminde formu bastan kur
    initForm() {
      this.resetForm();

      if (this.isEditMode) {
        this.getItem();
      } else {
        // Store'da onceki anket duruyorsa surveyItem watcher'ina takilmasin
        store.commit(MODULE_NAME + '/' + RESET_VALUES);
        this.addDropdownQuestion();
      }
    },
    resetForm() {
      this.errorMessages = [];
      this.selected_question_type = 1;
      this.questions = [];
      this.name = null;
      this.status_id = true;
      this.is_compulsory = false;
      this.is_default = false;
      this.send_completion_email = false;
      this.point = 0;
    },
    resetMessages() {
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    surveyItem: {
      handler(val) {
        if (val && this.isEditMode) {
          this.loadSurveyData();
        }
      },
      deep: true,
      immediate: true
    },
    error: function (val) {
      if (val) {
        this.scrollToTop();
        this.errorMessages.push(val);
      }
    },
    errorMessages() {
      if (this.debouncedResetValues) {
        this.debouncedResetValues();
      }
    },
    // Ayni component iki route'u da karsiliyor (add + edit). Router
    // instance'i yeniden olusturmadigi icin mounted() tekrar
    // calismiyor; edit -> add gecisinde eski anketin verisi ekranda
    // kaliyordu.
    "$route.params.id": function () {
      this.initForm();
    },
  },
  mounted() {
    this.initForm();
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 5000);
  },
}
</script>

<style scoped>
.question-item {
  background: rgb(251, 251, 251);
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #efefef;
}

/* ── Soru basligi ── */
.survey-question-head {
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.survey-question-head h4 {
  margin: 0;
  min-width: 0;
}

/* ── Secenek satiri ──
   align-items: flex-end ile sil butonu input'larla hizalaniyor;
   eskiden butona `margin-top: 1.8rem` veriliyordu ve etiket satir
   kirdiginda hiza kayiyordu. */
/* Edit modunda tek sekme var, nav gosterilmiyor */
.survey-tabs--single ::v-deep .company-tabs__nav {
  display: none;
}

.survey-option-row {
  /* Uc kontrol de ayni yuksekligi bu degiskenden aliyor */
  --survey-control-h: 38px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

/* 1) metin input'u */
.survey-option-row .form-control {
  box-sizing: border-box;
  height: var(--survey-control-h);
  min-height: var(--survey-control-h);
}

/* 2) puan dropdown'i (MultipleSelectInput -> vue-multiselect)
   !important sart: MultipleSelectInput'un kendi scoped stili
   `.multiselect { height: 40px !important }` diyor. Onsuz kok 40px
   kalirken icindeki gorunen kutu (__tags) 38px oluyor; satir
   flex-end hizalandigi icin dropdown digerlerinden 2px yukarida
   duruyordu. */
.survey-option-row ::v-deep .multiselect,
.survey-option-row ::v-deep .multiselect__tags {
  box-sizing: border-box;
  height: var(--survey-control-h) !important;
  min-height: var(--survey-control-h) !important;
  max-height: var(--survey-control-h) !important;
}

.survey-option-row ::v-deep .multiselect__tags {
  display: flex;
  align-items: center;
  padding: 0 32px 0 10px;
}

.survey-option-row ::v-deep .multiselect__single,
.survey-option-row ::v-deep .multiselect__placeholder,
.survey-option-row ::v-deep .multiselect__input {
  margin: 0;
  padding: 0;
  line-height: 1.4;
}

.survey-option-row ::v-deep .multiselect__select {
  top: 0;
  height: var(--survey-control-h);
}

/* 3) sil butonu — kare, ayni yukseklik.
   Kapsayici flex: buton `inline-flex` iken satir kutusunun strut'i
   (font descender'i) kapsayicinin altina ~4px bosluk ekliyordu;
   satir flex-end hizalandigi icin buton input/dropdown'dan yukarida
   kaliyordu. Blok seviyesinde flex ile satir kutusu hic olusmuyor. */
.survey-option-remove {
  display: flex;
  align-items: flex-end;
}

.survey-option-remove .uk-button {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: var(--survey-control-h);
  height: var(--survey-control-h);
  min-height: var(--survey-control-h);
  max-height: var(--survey-control-h);
  padding: 0;
  line-height: 1;
}

.survey-option-field {
  min-width: 0;
}

.survey-option-field--label {
  flex: 1 1 220px;
}

.survey-option-field--point {
  flex: 0 0 auto;
}

/* Puan tek/iki haneli; ok icin sagda 32px yer birakiliyor. Kolon
   genisligi bu min-width'ten geliyor, ustteki kisa etiket (~52px)
   artik daha genis degil. */
.survey-option-field--point ::v-deep .multiselect {
  width: auto;
  min-width: 72px;
  max-width: 96px;
}

/* WEB_UI_GUIDELINES: Label 14px/500, line-height 1.3-1.5
   (eskiden 13px idi; mobil guideline'da da label 14px) */
.survey-option-label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

/* Etiket kolonu sismesin; iki satira bolunmeden tek satirda kalsin */
.survey-option-field--point .survey-option-label {
  white-space: nowrap;
}

/* ── Soru ekleme satiri ── */
.survey-add-question {
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.survey-question-type-select {
  max-width: 200px;
}

/* ── Form altligi ──
   Eskiden ikinci butonda `margin-left: 5vh` vardi: yatay bosluk icin
   VIEWPORT YUKSEKLIGI birimi. Kisa/genis ekranda daraliyor, uzun
   telefonda buyuyordu. Yerine sabit gap. */
.survey-form-footer {
  flex-wrap: wrap;
  gap: 8px;
}

/* MultipleSelectInput koku .form-group; alt margin'i satiri sisiriyor */
.survey-option-row .form-group,
.survey-add-question .form-group {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .question-item {
    padding: 12px;
  }

  .survey-option-row {
    --survey-control-h: 44px;
  }

  /* Input + puan dropdown'i + sil ikonu AYNI satirda */
  .survey-option-row {
    flex-wrap: nowrap;
    gap: 4px;
  }

  .survey-option-row .p-2 {
    padding: 4px !important;
  }

  .survey-option-field--label {
    flex: 1 1 auto;
  }

  .survey-option-field--point {
    flex: 0 0 auto;
  }

  .survey-question-type-select {
    flex: 1 1 100%;
    max-width: none;
  }

  .survey-add-question {
    flex-direction: column;
    align-items: stretch;
  }

  .survey-add-question .btn {
    width: 100%;
    min-height: 48px;
  }

  /* Kaydet + Atama yap ayni satirda, esit paylasimli */
  .survey-form-footer {
    flex-wrap: nowrap;
  }

  .survey-form-footer .uk-button {
    flex: 1 1 0;
    min-width: 0;
    min-height: 48px;
    /* MOBILE_UI_GUIDELINES: Body 16px */
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
